import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { UI } from 'components/index'
import { isProduction } from 'helpers/Utils'
import { toast } from 'react-toastify'
import { formatNumber } from './controller'
import { defaultValues } from './constants'
import { createOdooContact } from 'api/CRM'
import Form from './Form'
import Result from './Result'

const CargaFinanciera = () => {
  const [result, setResult] = useState(null)
  const [showResults, setShowResults] = useState(false)
  const [loading, setLoading] = useState(false)

  const {
    watch,
    register,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues,
    mode: 'onBlur',
    // TODO: Validación de formulario con Yup
    // resolver: yupResolver(handleValidationResolver()),
  })

  const {
    renta_liquida,
    sueldo_variable,
    boletas_value,
    arriendos_value,
    credito_hipotecario,
    credito_consumo,
    cuotas_restantes,
    firstname: name,
    email,
    phone,
  } = watch()

  const handleAddContact = async () => {
    try {
      const payload = {
        name,
        email,
        phone,
        mobile: phone,
        x_campana: 'Simulador: Carga financiera',
      }
      // Solo funcionará en prod y no debe llevar await para que no corte la ejecución
      isProduction() && createOdooContact(payload)
    } catch (error) {
      console.error('Error al agregar contacto:', error)
    }
  }

  // Payload para simulación
  // const payload = {
  //   broker_email: 'userEmail@pepe.com',
  // }

  // Simulación con la API, se envía el payload y setea el resultado

  const handleSimulate = () => {
    try {
      const ufValue = 36064.2

      const ingresos =
        formatNumber(renta_liquida) +
        (formatNumber(sueldo_variable) + formatNumber(boletas_value)) * 0.7 +
        formatNumber(arriendos_value) * 0.5

      const creditos =
        formatNumber(credito_hipotecario) +
        formatNumber(credito_consumo) * formatNumber(cuotas_restantes)

      const operacion = (((ingresos - creditos) * 0.25) / ufValue) * 12 * 30

      const ufInvertir = Math.round(operacion * (1 - 5.2 / 12))
      handleAddContact()
      setResult(ufInvertir)
      setShowResults(true)
      setLoading(false)
      window.scrollTo(0, 0)

      toast.success('Simulación exitosa')
    } catch (error) {
      console.error('Error en la simulación:', error)
      toast.error('Hubo un error en la simulación')
    }
  }

  const resetSimulator = () => {
    setResult(null)
    setShowResults(false)
    reset(defaultValues)
    window.scrollTo(0, 0)
  }

  // Validación de formulario básico
  const validate = Boolean(name && email && phone)

  return (
    <div className="flex flex-col my-6 space-y-6">
      <UI.Header
        title={showResults ? 'Resultados' : '¿Cuánto me alcanza?'}
        subtitle={!showResults && 'conoce cuánta plata puedes pedir'}
      />
      {!showResults && (
        <Form
          watch={watch}
          register={register}
          setValue={setValue}
          errors={errors}
          handleSimulate={handleSimulate}
          loading={loading}
          isDisabled={!validate}
        />
      )}
      {showResults && result && <Result result={result} resetSimulator={resetSimulator} />}{' '}
    </div>
  )
}

export default CargaFinanciera
